import React, {useEffect} from 'react'
import {Typography, Box, Button, Paper} from '@mui/material'
import {useSelector, useDispatch} from 'react-redux'
import {RootState} from '../../redux/rootReducer'
import {actions as assignmentsSummaryActions} from '../../redux/modules/assignmentsSummary'
import styles from './styles'

const PLACEHOLDER = ' '

type KpiCardProps = {value?: number; label: string; hidden: boolean}

const KpiCard: React.FC<KpiCardProps> = ({value, label, hidden}) => (
  <Paper sx={hidden ? {...styles.kpiCard, ...styles.kpiCardHidden} : styles.kpiCard} elevation={1}>
    <Typography sx={styles.kpiValue} variant="h5">
      {hidden ? PLACEHOLDER : value ?? '—'}
    </Typography>
    <Typography sx={styles.kpiLabel} variant="body2">
      {hidden ? PLACEHOLDER : label}
    </Typography>
  </Paper>
)

const AssignmentDashboardTab: React.FC = () => {
  const dispatch = useDispatch()
  const {summary, loading, error} = useSelector((state: RootState) => state.assignmentsSummary)

  useEffect(() => {
    dispatch(assignmentsSummaryActions.get())
  }, [dispatch])

  // Error wins over loading so a Retry doesn't flash the stale cards; later refreshes keep them.
  const showError = Boolean(error)
  const showLoading = !showError && loading && !summary
  const hidden = showError || showLoading

  return (
    <Box sx={styles.kpiRow} role="group" aria-label="Assignment summary">
      <KpiCard value={summary?.activeAssignments} label="Active Assignments" hidden={hidden} />
      <KpiCard value={summary?.devicesInInventory} label="Devices in Inventory" hidden={hidden} />
      {showError && (
        <Box sx={styles.kpiOverlay}>
          <Typography color="error" variant="body2">
            {error}
          </Typography>
          <Button
            size="small"
            disabled={loading}
            onClick={() => dispatch(assignmentsSummaryActions.get())}>
            Retry
          </Button>
        </Box>
      )}
      {showLoading && (
        <Box sx={styles.kpiOverlay}>
          <Typography>Loading...</Typography>
        </Box>
      )}
    </Box>
  )
}

export default AssignmentDashboardTab
